import { Modal, Typography } from 'antd';

import { Button } from '@shared/components';

const { Text } = Typography;

const HSGChronicTierModal = () => {
  const onClose = () => {
    Modal.destroyAll();
  };

  return (
    <div className="flex flex-col gap-y-6">
      <div className="flex flex-col gap-y-2">
        <Text className="text-sm">
          The Healthier SG Chronic Tier can only be utilised at your enrolled clinic. Please note that only one subsidy
          tier may be used at each visit. The dollar subsidy will be pro-rated accordingly for the next visit, if a
          different subsidy tier is chosen.
        </Text>

        <Text className="text-sm">
          You can further enjoy subsidies with no dollar cap for selected chronic medications under Healthier SG:
        </Text>
        <ul className="ml-5 list-disc">
          <li>SDL Drugs: 75% Subsidy</li>
          <li>MAF Drugs: 75% Subsidy</li>
        </ul>
      </div>

      <Button className="w-full" onClick={onClose}>
        OK
      </Button>
    </div>
  );
};

export default HSGChronicTierModal;
